import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { camelCase } from 'lodash';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { connect } from 'react-redux';
import * as actions from '../store/actions/index';
import { withRouter } from 'react-router-dom';

const styles = theme => ({
    root: {
      //width: '70%',
      //minHeight: '500px',
      //marginTop: theme.spacing.unit * 3,
      overflowX: 'auto',
      margin: '0 Auto',
      //display: 'flex',
      //justifyContent: 'center',
    },
    head:{
        fontSize: 14,
        fontWeight: 'bold',
        backgroundColor: '#B71C1C',
        color: 'white',
    },
    table: {
        tableLayout: 'auto',
        minWidth: 300,
    },
    leftCell: {
        borderRight: '0.1em solid rgba(224, 224, 224, 1)',
    },
  });
  


function createData(amountInDispute, fee) {
  return { amountInDispute, fee};
}

const rows = [
    createData('At or below $1,000', '100.00'),
    createData('At or between $1,001 and $2,000', '200.00'),
    createData('At or between $2,001 and $5,000', '500.00'),
    createData('At or between $5,001 and $10,000', '1,000.00'),
    createData('At or between $10,001 and $15,000', '1,500.00'),
    createData('At or between $15,001 and $20,000', '2,000.00'),
    createData('At or between $20,001 and $50,000', '2,500.00'),
    createData('At or between $50,001 and $100,000', '5,000.00'),
    createData('At or between $100,001 and $150,000', '7,500.00'),
    createData('At or between $150,001 and $250,000', '12,500.00'),
    // createData('At or between $250,001 and $500,000', '25,000.00'),
    // createData('At or between $500,001 and $1,500,000', '37,500.00'),
    // createData('At or between $1,500,001 and $3,000,000', '75,000.00'),
    // createData('At or between $3,000,001 and $10,000,000', '125,000.00'),
    createData('Over $250,000', '25,000.00'),
  ];
//相等或介乎於港幣$1,001及港幣$2,000之間
  const chi_rows = [
    createData('相等或介乎於港幣$1,000 或以下', '100.00'),
    createData('相等或介乎於港幣$1,001 及港幣$2,000之間', '200.00'),
    createData('相等或介乎於港幣$2,001 及港幣$5,000之間', '500.00'),
    createData('相等或介乎於港幣$5,001 及港幣$10,000之間', '1,000.00'),
    createData('相等或介乎於港幣$10,001 及港幣$15,000之間', '1,500.00'),
    createData('相等或介乎於港幣$15,001 及港幣$20,000之間', '2,000.00'),
    createData('相等或介乎於港幣$20,001 及港幣$50,000之間', '2,500.00'),
    createData('相等或介乎於港幣$50,001 及港幣$100,000之間', '5,000.00'),
    createData('相等或介乎於港幣$100,001 及港幣$150,000之間', '7,500.00'),
    createData('相等或介乎於港幣$150,001 及港幣$250,000之間', '12,500.00'),
    // createData('相等或介乎於港幣$250,001及港幣$500,000', '25,000.00'),
    // createData('相等或介乎於港幣$500,001及港幣$1,500,000', '37,500.00'),
    // createData('相等或介乎於港幣$1,500,001及港幣$3,000,000', '75,000.00'),
    // createData('相等或介乎於港幣$3,000,001及港幣$10,000,000', '125,000.00'),
    createData('超過港幣$250,000', '25,000.00'),
  ];


class ArbitratorFeeTable extends Component{
    render(){
        const { classes } = this.props;
        return (
            <Paper className={classes.root}>
                <Table className={classes.table} fixedHeader={false}>
                    <TableHead>
                        <TableRow style={{height: '40px'}}>
                            <TableCell colSpan={2} align="center" component="th" padding="dense" className={classes.head}> 
                                {this.context.t('Online Arbitration Fees')}
                            </TableCell> 
                        </TableRow>
                        <TableRow style={{height: '40px'}}>
                            <TableCell align="left" className={classes.head}>{this.context.t('For an amount in dispute (HK$)')}</TableCell>
                            <TableCell align="right" className={classes.head}>{this.context.t('Arbitration Fees (HK$)')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                         { 
                          this.props.lang =='en' && rows.map((row, index) => (
                                <TableRow key={row.index} hover style={{height: 16}}>
                                    <TableCell className={classes.leftCell} component="th" scope="row" style={{fontSize: 12}}>
                                        {row.amountInDispute}
                                    </TableCell>
                                    <TableCell align="right" style={{fontSize: 12}}>{row.fee}</TableCell>
                                </TableRow>
                            ))
                        }
                        { 
                          this.props.lang =='cn' && chi_rows.map((row, index) => (
                                <TableRow key={row.index} hover style={{height: 16}}>
                                    <TableCell className={classes.leftCell} component="th" scope="row" style={{fontSize: 12}}>
                                        {row.amountInDispute}
                                    </TableCell>
                                    <TableCell align="right" style={{fontSize: 12}}>{row.fee}</TableCell>
                                </TableRow>
                            ))
                        }
                    </TableBody>
                </Table>
          </Paper>
        );
    }
    
}


ArbitratorFeeTable.contextTypes = {
    t: PropTypes.func
  }


const mapStateToProps = (state) => {
    return {
        lang: state.i18nState.lang,
    }
}

const mapDispatchToProps = (dispatch) => {
return {
    saveArbiAgreement: (date,firstPartyName,secondPartyName,firstPartyEmail,secondPartyEmail, description, firstsig,secondsig) => dispatch(actions.saveArbiAgreement(date,firstPartyName,secondPartyName,firstPartyEmail,secondPartyEmail, description, firstsig,secondsig)),
}
}

// export default withStyles(styles)(ArbitrationAgreement);
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withRouter(ArbitratorFeeTable)));
// export default withStyles(styles)(ArbitratorFeeTable);


